'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MinhaContaLinkUnlogged = exports.MinhaContaLinkLogged = exports.MinhaContaLinkDefault = undefined;
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  min-width: 104px;\n  height: 48px;\n  ', '\n  ', '\n'], ['\n  min-width: 104px;\n  height: 48px;\n  ', '\n  ', '\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n    & > span {\n      display: none;\n    }\n    margin-left: 0;\n  '], ['\n    & > span {\n      display: none;\n    }\n    margin-left: 0;\n  ']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
  _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 4px;\n  transform: rotate(90deg);\n'], ['\n  margin-left: 4px;\n  transform: rotate(90deg);\n']),
  _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  &:hover {\n    ', ' {\n      display: block;\n    }\n  }\n'], ['\n  position: relative;\n  &:hover {\n    ', ' {\n      display: block;\n    }\n  }\n']),
  _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _medias = require('../../../util/medias');
var _medias2 = _interopRequireDefault(_medias);
var _user = require('../../../assets/icons/user');
var _user2 = _interopRequireDefault(_user);
var _chevronRight = require('../../../assets/icons/chevronRight');
var _chevronRight2 = _interopRequireDefault(_chevronRight);
var _staticUrl = require('../../../config/staticUrl');
var _View = require('../../atoms/View');
var _View2 = _interopRequireDefault(_View);
var _Icon = require('../../atoms/Icon');
var _Icon2 = _interopRequireDefault(_Icon);
var _UserAvatar = require('../../atoms/UserAvatar');
var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
var _MyLinkBox = require('./MyLinkBox');
var _MyLinkBox2 = _interopRequireDefault(_MyLinkBox);
var _MyHeaderSubMenu = require('./MyHeaderSubMenu');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var LinkBoxOfUser = (0, _styledComponents2.default)(_MyLinkBox2.default)(_templateObject, _medias2.default.small(_templateObject2), function (props) {
  return props.isLogged && _medias2.default.medium(_templateObject3);
});
var DownChevron = (0, _styledComponents2.default)(_Icon2.default)(_templateObject4);
var MinhaContaLinkLoggedWraper = (0, _styledComponents2.default)(_View2.default)(_templateObject5, _MyHeaderSubMenu.HeaderSubMenuDesktop);
var InnerMyAccount = _styledComponents2.default.div(_templateObject6);
var MinhaContaLinkDefault = exports.MinhaContaLinkDefault = function MinhaContaLinkDefault() {
  return _react2.default.createElement(LinkBoxOfUser, {
    url: _staticUrl.minhaConta,
    innerRender: 'Minha conta'
  }, _react2.default.createElement(_Icon2.default, {
    width: 24,
    height: 24,
    svgPath: _user2.default
  }));
};
var MinhaContaLinkLogged = exports.MinhaContaLinkLogged = function MinhaContaLinkLogged(_ref) {
  var hasBadge = _ref.hasBadge,
    userName = _ref.userName,
    profilePictureUrl = _ref.profilePictureUrl,
    notifications = _ref.notifications,
    userProfileLink = _ref.userProfileLink;
  return _react2.default.createElement(MinhaContaLinkLoggedWraper, null, _react2.default.createElement(LinkBoxOfUser, {
    hasBadge: hasBadge,
    innerRender: function innerRender() {
      return _react2.default.createElement(InnerMyAccount, null, _react2.default.createElement('span', null, userName), _react2.default.createElement(DownChevron, {
        width: 16,
        height: 16,
        svgPath: _chevronRight2.default
      }));
    },
    isLogged: true
  }, _react2.default.createElement(_UserAvatar2.default, {
    size: 32,
    imageUrl: profilePictureUrl,
    alt: userName
  })), _react2.default.createElement(_MyHeaderSubMenu.HeaderSubMenuDesktop, {
    isLogged: true,
    isDropDown: true,
    userName: userName,
    notifications: notifications,
    userProfileLink: userProfileLink
  }));
};
MinhaContaLinkLogged.propTypes = {
  userName: _propTypes2.default.string,
  profilePictureUrl: _propTypes2.default.string,
  hasBadge: _propTypes2.default.bool,
  notifications: _propTypes2.default.number,
  userProfileLink: _propTypes2.default.string
};
var MinhaContaLinkUnlogged = exports.MinhaContaLinkUnlogged = function MinhaContaLinkUnlogged() {
  return _react2.default.createElement(LinkBoxOfUser, {
    url: _staticUrl.minhaConta,
    innerRender: 'Entrar'
  }, _react2.default.createElement(_Icon2.default, {
    width: 24,
    height: 24,
    svgPath: _user2.default
  }));
};